module.exports = __webpack_public_path__ + "img/business14.8e14a483.png";